export * from './methods'
export * from './slice'
export * from './types'
import UserReducer from './slice'

export {UserReducer}
